{
  "INTEGRATION_APPS": {
    "FETCHING": "Đang lấy Tích hợp",
    "NO_HOOK_CONFIGURED": "Không có tích hợp {integrationId} được cấu hình đối với tài khoản này.",
    "HEADER": "Ứng dụng",
    "STATUS": {
      "ENABLED": "Bật",
      "DISABLED": "Không bật"
    },
    "CONFIGURE": "Cấu hình",
    "ADD_BUTTON": "Thêm một hook mới",
    "DELETE": {
      "TITLE": {
        "INBOX": "Xác nhận xoá",
        "ACCOUNT": "Ngắt kết nối"
      },
      "MESSAGE": {
        "INBOX": "Bạn có chắc muốn xoá?",
        "ACCOUNT": "Bạn có chắc muốn ngắt kết nối?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Có, Xoá",
        "ACCOUNT": "Có, ngắt kết nối"
      },
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "API": {
        "SUCCESS_MESSAGE": "Hook đã được xoá thành công",
        "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
      }
    },
    "LIST": {
      "FETCHING": "Đang lấy hook tích hợp",
      "INBOX": "Hộp thư đến",
      "EDIT": {
        "BUTTON_TEXT": "Chỉnh sửa"
      },
      "DELETE": {
        "BUTTON_TEXT": "Xoá"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Chọn Hộp thư đến",
          "PLACEHOLDER": "Chọn Hộp thư đến"
        },
        "SUBMIT": "Tạo",
        "CANCEL": "Huỷ"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook tích hợp đã được thêm thành công",
        "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
      }
    },
    "EDIT": {
      "TITLE": "Chỉnh sửa {name}",
      "FORM": {
        "SUBMIT": "Cập nhật",
        "CANCEL": "Huỷ"
      },
      "API": {
        "SUCCESS_MESSAGE": "Đã cập nhật hook tích hợp thành công",
        "ERROR_MESSAGE": "Không thể kết nối tới máy chủ trò chuyện, vui lòng thử lại sau"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Kết nối"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Ngắt kết nối"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Đồng bộ email và web chat với tài khoản Daktela của bạn.",
      "RETINO": "Retino giúp việc quản lý trả hàng và khiếu nại trở nên gọn gàng hơn.",
      "MAILSHIP": "Mailship là hệ thống quản lý kho và xử lý đơn hàng. Tra cứu trạng thái đơn hàng, theo dõi vận chuyển và chi tiết gửi hàng.",
      "RAYNET": "Kết nối tài khoản Raynet CRM của bạn để truy cập dữ liệu khách hàng. Thêm kết nối bằng tên người dùng và mã thông báo API Raynet của bạn."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Kiểm tra kết nối",
      "SUCCESS": "Kết nối thành công",
      "ERROR": "Kết nối thất bại. Vui lòng kiểm tra thông tin đăng nhập của bạn."
    }
  }
}
